export default "__VITE_ASSET__WNvv$fKm__"